export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12405.ad45d1f7.jpg";